/** Shape shared by UNIT list responses used with offset paging + react-query infinite queries. */
export type PagedListLastPage = {
  paging: { offset: number; total: number };
  objects: unknown[];
};

export const getNextPageOffsetFromPagedList = (lastPage: PagedListLastPage): number | undefined => {
  const nextOffset = lastPage.paging.offset + lastPage.objects.length;
  return nextOffset < lastPage.paging.total ? nextOffset : undefined;
};

export const flatMapInfinitePages = <T,>(
  data: { pages: Array<{ objects: T[] }> } | undefined,
): T[] => data?.pages.flatMap((p) => p.objects) ?? [];
